import { Component, OnInit, Input, AfterViewInit, ViewEncapsulation, ViewChildren, QueryList, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'renault-ng-feedback',
  template: `
  <div id="renaultNgFeedbackContainer" *ngIf="applicationQueId && irnSelected && ipnSelected">
  <div class="backdrop" *ngIf="showAttachOverlay"></div>
  <div [hidden]="!isShow">
      <div class="content" [ngClass]="{'translateAttach': showAttachOverlay}" *ngFor="let appPluginDetails of pluginDetails">
        <div *ngFor="let appDefaultPluginDetails of defaultPluginDetails">
          <button *ngIf="!triggerId" class="close" type="button" (click)="featureHide()">&times;</button>
          <div class="card text-white feedback-btn" [ngStyle]="{'background-color' : pluginColor }" [ngClass]="{'fixed' : showAttachOverlay}"
              (click)="showOverlay()">
              <div class="card-body" [ngStyle]="{'background-color' : pluginColor }"><b id="provide-header">{{ appPluginDetails.pluginData.pluginHeader}}</b> <button class="close1" type="button"
                      (click)="showOverlay($event)" [ngStyle]="{'color' : pluginColor }">&times;</button>
                  <div *ngIf="!triggerId" class="feedbkimg float-right"></div>
              </div>
          </div>
          <div class="reanult-feedback feedback-container text-center" [ngClass]="{'pr-0': showQuestions, 'no-selection': hideBtn}"
              *ngIf="showAttachOverlay">
              <div class="error" style="background-color: red;
              font-weight: normal;
              border: 1px solid red;
              padding: 5px;
              font-size: 15px;
              margin-bottom: 0px;
              position: absolute;
              top: 66px;
              width: 100%;
              left: 0;
              z-index: 9999;
              display: flex;
              align-items: center;
              color: white;" *ngIf="backEndError || showErrorMsg">
                  <span *ngIf="showErrorMsg">{{showErrorMsg}}</span>
                  <ng-container *ngIf="!showErrorMsg">
                    <span>Something went wrong.Please try after sometime !</span>
                  </ng-container>
                  <div style="cursor: pointer;display: inline-flex;align-items:center;justify-content:center;width: 30px;height: 30px;border-radius: 50%;border: 1px solid #fff;
                      background-color: #fff;
                      color: #f00;
                      font-size: 24px;" (click)="backEndError = false;showErrorMsg=''">
                      <span style="padding-bottom: 5px;">&times;</span></div>
              </div>
              <ng-container *ngIf="!showQuestions">
                  <div class="margin-bottom-16">{{ appPluginDetails.pluginData.pluginDescription || 'We would like your feedback to improve the website' }}</div>
                  <div class="smileys margin-bottom-16">
                      <div class="emoji  emoji--angry" [ngClass]="{'selected': emojiAngry, 'hovered': emojiAngryHov}"
                      [attr.data-emojiAngry]="appPluginDetails.pluginData.pluginEmoji1">
                          <input type="radio" name="tired" (mouseleave)="emojiAngryHov = false"
                              (mouseover)="changeEmHov();emojiAngryHov=true"
                              (change)="changeEmoji(1);emojiAngry = true" />
                          <div class="check"></div>
                          <div class="emoji__face">
                              <div class="emoji__eyebrows"></div>
                              <div class="emoji__eyes"></div>
                              <div class="emoji__mouth"></div>
                          </div>
                      </div>
                      <div class="emoji  emoji--sad" [ngClass]="{'selected': emojiSad, 'hovered': emojiSadHov}"
                      [attr.data-emojiSad]="appPluginDetails.pluginData.pluginEmoji2">
                          <input type="radio" name="tired" (mouseleave)="emojiSadHov = false"
                              (mouseover)="changeEmHov();emojiSadHov=true"
                              (change)="changeEmoji(2);emojiSad = true" />
                          <div class="check"></div>
                          <div class="emoji__face">
                              <div class="emoji__eyebrows"></div>
                              <div class="emoji__eyes"></div>
                              <div class="emoji__mouth"></div>
                          </div>
                      </div>
                      <div class="emoji  emoji--yay" [ngClass]="{'selected': emojiYay, 'hovered': emojiYayHov}"
                      [attr.data-emojiYay]="appPluginDetails.pluginData.pluginEmoji3">
                          <input type="radio" name="tired" (mouseleave)="emojiYayHov = false"
                              (mouseover)="changeEmHov();emojiYayHov=true"
                              (change)="changeEmoji(3);emojiYay = true" />
                          <div class="check"></div>
                          <div class="emoji__face">
                              <div class="emoji__eyebrows"></div>
                              <div class="emoji__mouth"></div>
                          </div>
                      </div>
                      <div class="emoji  emoji--wow" [ngClass]="{'selected': emojiWow, 'hovered': emojiWowHov}"
                      [attr.data-emojiWow]="appPluginDetails.pluginData.pluginEmoji4">
                          <input type="radio" name="tired" (mouseleave)="emojiWowHov = false"
                              (mouseover)="changeEmHov();emojiWowHov=true"
                              (change)="changeEmoji(4);emojiWow = true" />
                          <div class="check"></div>
                          <div class="emoji__face">
                              <div class="emoji__eyebrows"></div>
                              <div class="emoji__eyes"></div>
                              <div class="emoji__mouth"></div>
                          </div>
                      </div>
                  </div>
                  <div style="color:red;" *ngIf="!rating && invalidTrigger">Please select the rating</div>
                  <div class="pt-3 d-block screenShot-content" *ngIf="emojiSelected">
                      <div class="screenshot-feedback">
                          <textarea *ngIf="showComments" [ngClass]="showScreenShot ? 'comment-section' : 'comment-section no-screenShot'"
                              (input)="descriptionScreenshot = $event.target.value" placeholder={{appPluginDetails.pluginData.pluginComment}}
                              maxlength="200" class="comment-section"></textarea>
                              <div *ngIf="showComments && (emojiAngry || emojiSad) && descriptionScreenshot?.length < 10" style ="color:#ff0000;font-size:10px;text-align:left;margin-left:25px;">
                               {{appDefaultPluginDetails.mgs1}}
                             </div>
                            <div *ngIf="showScreenShot" style="text-align:right;">
                              <label for="file-upload" class="custom-file-upload" >
                              <img src="https://app-ufo.gke.ope.gcp.renault.com/assets/attachment.png" style="width:35px; height:25px; padding-right:2px;" alt= {{appDefaultPluginDetails.mgs2}} title= {{appDefaultPluginDetails.mgs2}} />
                              </label>
                              <input type="file" accept="image/*" id="file-upload" title={{appDefaultPluginDetails.mgs2}} #fileInput (click)="fileInput.value = null" (change)="imageConvert($event)">
                              <span *ngIf="screenShotName" class="custom-file-upload" (click)="resetScreenshot()">{{screenShotName}}<span style="font-size:20px; vertical-align: super;
                              font-weight: 600;">&times;</span></span>
                            </div>
                      </div>
                    </div>
                    <div class="pt-3 d-block questions-link">
                    <a
                    href="javascript:void(0);"
                    *ngIf="showQuestionsFlag && showQuestionLink &&   (!(emojiAngry || emojiSad) || !showComments || ((emojiAngry || emojiSad) && descriptionScreenshot?.length >= 10)) "
                    (click)="showQu()"
                    style="color:#000000"
                    ><b>{{appPluginDetails.pluginData.pluginSurveyDescription}}<span style="color:#ff0000">*</span></b></a
                  >
                  <a
                  href="javascript:void(0);"
                  *ngIf="showQuestionsFlag && showQuestionLink &&  (showComments && (emojiAngry || emojiSad) && descriptionScreenshot?.length <10) "
                  style="color:#000000"
                  >{{appPluginDetails.pluginData.pluginSurveyDescription}}<span style="color:#ff0000">*</span></a
                >    
                    </div>
              </ng-container>
              <div #questionsTabTag class="questions-tab" *ngIf="showQuestions && !thanksNote">
                  <div #questionsTag [ngClass]="{'show': first}" class="question question-{{index}}"
                      *ngFor="let question of questions;let index=index;let first=first">
                      <div class="question-text">{{index + 1}}: {{question.description}}</div>
                      <ng-container [ngSwitch]="question?.option?.id">
                          <ng-container *ngSwitchCase='3'>
                              <div class="options relative"
                                  *ngFor="let option of question?.option?.choices?.split(',')">
                                  <input type="radio" [value]="option" name="question{{index}}"
                                      (change)="goToNextQues(question,index,$event)" />
                                  <div class="radio-check"></div>
                                  <span>{{option}}</span>
                              </div>
                          </ng-container>
                          <ng-container *ngSwitchCase='1'>
                              <div class="options relative" *ngFor="let option of splitOptions(question?.option?.description)">
                              <input type="radio" [value]="option" name="question{{index}}"
                              (change)="goToNextQues(question,index,$event)" />
                              <div class="radio-check"></div>
                              <span>{{option}}</span>
                              </div>
                          </ng-container>
                          <ng-container *ngSwitchCase='2'>
                              <div class="options relative">
                                  <textarea name="comments" maxlength="300" id="comments{{index}}" cols="30" rows="10"
                                      placeholder= {{appDefaultPluginDetails.mgs3}}
                                      (focusout)="goToNextQues(question,index,$event)"></textarea>
                              </div>
                          </ng-container>
                      </ng-container>

                  </div>
              </div>
              <div class="thanks-note" *ngIf="thanksNote">
              {{appDefaultPluginDetails.mgs5}}
              </div>
              <div class="btn-container" [ngStyle]="{'background-color' :pluginColor , 'left' : '-15px' , 'width' : '104%'}" [ngClass]="{'hide-btn' : thanksNote,'show-bg': showQuestions}">
                  <div *ngIf="showQuestions && !thanksNote" class="progress-bar">
                      <div class="fill" [style.width]="dynamicWidth + '%'"></div>
                  </div>
                  <span *ngIf="showQuestions && !thanksNote" class="count-question">{{questionCount}} of
                      {{questions?.length}}
                      {{appDefaultPluginDetails.mgs4}}</span>
                  <button
                  [disabled] = " (!rating || showErrorMsg || inProgress) || (showComments && (emojiAngry || emojiSad) && descriptionScreenshot?.length < 10) || (showQuestionsFlag &&  showQuestionLink && !showQuestions)"
                  [ngStyle]="{'background-color': pluginColor,'border-color': pluginColor, 'color': pluginColor}" 
                      [ngClass]="{'hide-bg': thanksNote || hideBtn}" class="btn btn-warning my-3 submit-btn" (click)="submit()">
                      <i *ngIf="inProgress" class="far fas fa fa-spinner"></i>
                      {{thanksNote ? '' : appPluginDetails.pluginData.pluginSubmit}}
                      <i *ngIf="!hideBtn" #replaceTag class="far fa-paper-plane fa-lg replace"></i>
                      <i *ngIf="!hideBtn" #planeTag class="far fa-paper-plane plane fa-lg hidden"></i>
                  </button>
              </div>
              <div class="poweredby"><img src="https://app-ufo.gke.ope.gcp.renault.com/assets/powered.png" style="width:20px; height:25px; background:#1e5799" />{{appDefaultPluginDetails.mgs6}} HAPPI -<span> 2023_R1</span></div>
          </div>
      </div>
  </div>
  </div>
</div>
  `,
  styleUrls: ['ng-renault-feedback.component.scss',
    'bootstrap.min.css',
    'all.min.css']
})
export class NgRenaultFeedbackComponent implements AfterViewInit {
  public emojiAngry: boolean = false;
  public emojiSad: boolean = false;
  public emojiMeh: boolean = false;
  public emojiYay: boolean = false;
  public emojiWow: boolean = false;
  public emojiAngryHov: boolean = false;
  public emojiSadHov: boolean = false;
  public emojiMehHov: boolean = false;
  public emojiYayHov: boolean = false;
  public emojiWowHov: boolean = false;
  public showAttachOverlay: boolean = false;
  public showQuestions: boolean = false;
  public questionCount: number = 0;
  public dynamicWidth: number = 0;
  public thanksNote: boolean = false;
  public rating: number = 0;
  public allQuestions: any = [];
  public invalidTrigger: boolean = false;
  public backEndError: boolean = false;
  public answered: any = [];
  public questions: any = [];
  public irnSelected: string = '';
  public ipnSelected: string = '';
  public clientId: string = '';
  public clientSecret: string = '';
  public techIPN: string = '';
  public techPassword: string = '';
  public apiKey: string = '';
  public totalRes: any = {};
  public inProgress: boolean = false;
  public screenshot: any;
  public screenShotName = '';
  public descriptionScreenshot = '';
  public showScreenShot = true;
  public showComments = true;
  public showQuestionsFlag = true;
  isShow = true;
  public emojiSelected = true;
  public hideBtn = false;
  @Input('access_token') public access_token: string = '';
  public showQuestionLink: boolean = true;
  public idpFailureCount: number = 10;
  public showErrorMsg: string = '';
  public applicationQueId: string = '';
  public pluginDetails: any = [];
  public defaultPluginDetails: any = [];
  browserLan: string = window.navigator.languages.toString();
  public appLan : string= this.browserLan.slice(0, 2);
  @Input('is-authorized') public isAuth: boolean = false;
  @Input('plugincolor') public pluginColor: string = '';
  @Input('pluginheader') public pluginHeader: string = '';
  @Output() public loaded: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public onHide: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChildren('questionsTag') questionsTag: QueryList<ElementRef>;
  @ViewChild('questionsTabTag', { static: false }) questionsTabTag: ElementRef;
  @ViewChild('planeTag', { static: false }) planeTag: ElementRef;
  @ViewChild('replaceTag', { static: false }) replaceTag: ElementRef;
  @ViewChild('feedbackBtn', { static: false }) feedbackBtn: ElementRef;
  @Input('triggerid') public triggerId: string;
  @Input('apiurl') public apiUrl: string = 'https://apis-dev.renault.com/ufo/v1/';
  @Input('base_url') public baseUrl: string = '';
  @Input('irn') set irn(val: string) {
    this.irnSelected = val;
  }

  @Input('ipn') set ipn(val: string) {
    this.ipnSelected = val;
  }
  @Input('client_id') set client_id(val: string) {
    this.clientId = val;
  }
  @Input('client_secret') set client_secret(val: string) {
    this.clientSecret = val;
  }
  @Input('tech_ipn') set tech_ipn(val: string) {
    this.techIPN = val;
  }
  @Input('tech_pass') set tech_pass(val: string) {
    this.techPassword = val;
  }
  @Input('apikey') set apikey(val: string) {
    this.apiKey = val;
  }
  
    
  constructor() {
  }
  
   ngOnInit() {
}

  ngAfterViewInit() {
    if (this.triggerId) {
      const btnId: any = document.getElementById(this.triggerId);
      if (btnId) {
        btnId.addEventListener('click', () => {
          this.showOverlay();
        });
      }
    }
    // if (this.apiKey) {
    //   this.hitIDP();
    // } else {
    //   this.fetchQuestions();
    // }
    if (localStorage.getItem("IDPAccessToken")) {
      this.fetchQuestions();
    }
  }

  fetchQuestions() {
    if (this.irnSelected && this.ipnSelected) {
      const apiUrl = this.apiKey ? this.apiUrl + 'questions' : this.baseUrl + '/appquestions';
      const http = new XMLHttpRequest();
      const url = `${apiUrl}?irn=${this.irnSelected}&ipn=${this.ipnSelected}&appLan=${this.appLan}`;
      http.open('GET', url, true);
      http.setRequestHeader("Content-Type", "application/json");
      http.setRequestHeader('apikey', this.apiKey);
      this.access_token = 'Bearer ' + localStorage.getItem("IDPAccessToken");
      http.setRequestHeader('Authorization', this.access_token);
      // if (this.apiKey) {
      //   http.setRequestHeader('apikey', this.apiKey);
      //   http.setRequestHeader('Authorization', this.access_token);
      // } else if (this.isAuth) {
      //   http.setRequestHeader('Authorization', this.access_token);
      // }
      http.onreadystatechange = () => {
        if (http.readyState === 4) {
          if (http.status === 200) {
            const res = http.responseText ? JSON.parse(http.responseText) : '';
            if (res && res.applicationQuestionId) {
              this.pluginDetails =res.appQuestiondetails;
              this.allQuestions = res.appQuestions;
              this.pluginHeader = res.pluginHeader;
              this.pluginColor = res.pluginColor;
              this.showScreenShot = res.enableScreenshot;
              this.showComments = res.enableGlobalFeedback;
              this.showQuestionsFlag = res.enableQuestions;
              if (!(this.showQuestionsFlag || this.showScreenShot || this.showComments)) {
                this.hideBtn = true;
              }
              this.totalRes = res;
              this.applicationQueId = res.applicationQuestionId;
              this.loaded.emit(true);
              this.defaultPluginDetails = this.element.filter(res => res.lan == this.pluginDetails[0].language);
            } else {
              this.pluginDetails =res.appQuestiondetails;
              this.allQuestions = [];
              this.applicationQueId = '';
              this.loaded.emit(false);
            }
          } else {
            this.pluginDetails =[];
            this.allQuestions = [];
            this.applicationQueId = '';
            this.loaded.emit(false);
          }
        }
      };
      http.send();
    }
  }

  changeEmoji(rating: number) {
    this.rating = +rating;
    this.showQuestionLink = !!this.allQuestions.find(x => x.rating === this.rating);
    this.emojiSelected = rating !== 0 ? true : false;
    this.emojiAngry = this.emojiMeh = this.emojiSad = this.emojiWow = this.emojiYay = false;
    if (!(this.showQuestionsFlag || this.showScreenShot || this.showComments)) {
      this.submit();
    }
  }

  changeEmHov() {
    this.emojiAngryHov = this.emojiMehHov = this.emojiSadHov = this.emojiWowHov = this.emojiYayHov = false;
  }
  featureHide() {
    this.isShow = false;
    this.onHide.emit(true);
  }

  showQu() {
    if (!this.rating) {
      this.invalidTrigger = true;
      return;
    }
    this.invalidTrigger = false;
    this.showQuestions = true;
    this.answered = [];
    const questions = this.allQuestions.find(x => x.rating === this.rating);
    this.questions = questions ? questions.questions : '';
    if (!this.questions) {
      return;
    }
    setTimeout(() => {
      const ele = this.questionsTabTag.nativeElement;
      ele.addEventListener('scroll', (event) => {
        const scrollEle = this.questionsTabTag.nativeElement;
        if (scrollEle) {
          const bounding = scrollEle.getBoundingClientRect();
          const top = bounding.top;
          const bottom = bounding.bottom;
          this.questionsTag.forEach((questionEle: any) => {
            const childBounding = questionEle.nativeElement.getBoundingClientRect();
            questionEle.nativeElement.classList.remove('show');
            if ((childBounding.top + 5) > top && (childBounding.top) < (bottom + 20)) {
              questionEle.nativeElement.classList.add('show');
            }
          });
        }
      });
    }, 500);
  }

  showOverlay($event?: any) {
    this.showAttachOverlay = !this.showAttachOverlay;
    this.invalidTrigger = false;
    this.showQuestions = false;
    this.backEndError = false;
    this.dynamicWidth = this.questionCount = 0;
    this.thanksNote = false;
    this.showErrorMsg = '';
    this.inProgress = false;
    if ($event) {
      $event.stopImmediatePropagation();
      $event.preventDefault();
    }
    this.changeEmoji(0);
    this.screenShotName = '';
    this.descriptionScreenshot = '';
    this.screenshot = '';
  }

  imageConvert(event) {
    const imagefile = event.target.files[0];
    this.screenShotName = imagefile.name.slice(0, 15);
    let fileReader = new FileReader();
    fileReader.onloadend = (e) => {
      let imageData = fileReader.result;
      let base64data = (<string>imageData).split("base64,");
      let rawData: string;
      if (base64data.length > 1) {
        this.screenshot = base64data[1];
      }
    }
    fileReader.readAsDataURL(imagefile);
    
  }

  splitOptions(description: string): string[] {
    if (!description) return [];
    const firstSplitArray = description.split(' ');
    let finalArray = [];
    for (let item of firstSplitArray) {
      finalArray = finalArray.concat(item.split('/'));
    }
    return finalArray;
  }

  submit() {
    if (!this.rating || this.inProgress) {
      return;
    }
    this.backEndError = false;
    const http = new XMLHttpRequest();
    const url = this.apiKey ? this.apiUrl + 'feedbacks?irn=' + this.irnSelected : this.baseUrl + '/appfeedBack?irn=' + this.irnSelected;
    const data = {
      'appQuesID': this.totalRes.applicationQuestionId,
      'userIPN': this.ipnSelected,
      'rating': this.rating,
      'answers': this.answered.filter(x => x),
      'imageData': this.screenshot,
      'fileName': this.screenShotName,
      'userComments': this.descriptionScreenshot
    };
    http.open('POST', url, true);
    http.setRequestHeader("Content-Type", "application/json");
    http.setRequestHeader('apikey', this.apiKey);
      this.access_token = 'Bearer ' + localStorage.getItem("IDPAccessToken");
      http.setRequestHeader('Authorization', this.access_token);
      // if (this.apiKey) {
      //   http.setRequestHeader('apikey', this.apiKey);
      //   http.setRequestHeader('Authorization', this.access_token);
      // } else if (this.isAuth) {
      //   http.setRequestHeader('Authorization', this.access_token);
      // }
    this.inProgress = true;
    this.showErrorMsg = '';
    http.onreadystatechange = () => {
      const res: any = http.responseText;
      if (http.readyState === 4 && http.status === 201) {
        if (res) {
          this.ipnSelected='';
          // if (res.toLowerCase().includes('reached the submission limit')) {
          //   this.showErrorMsg = JSON.parse(res).message;
          // } else if (res.toLowerCase().includes('feedback helps')) {
          //   if (!this.hideBtn) {
          //     const plane: any = this.planeTag.nativeElement;
          //     const hidden: any = this.planeTag.nativeElement;
          //     const replace: any = this.replaceTag.nativeElement;
          //     plane.classList.add('fly');
          //     hidden.classList.add('visible');
          //     replace.classList.remove('fa-paper-plane');
          //     replace.classList.add('fa-check-circle');
          //     replace.classList.add('nav-center');
          //   }
          //   this.thanksNote = this.showQuestions = true;
          //   setTimeout(() => {
          //     this.showAttachOverlay = false;
          //     this.fetchQuestions();
          //   }, 2500);
          // }
          // this.inProgress = false;
        }
      }
    };
    if (!this.hideBtn) {
      const plane: any = this.planeTag.nativeElement;
      const hidden: any = this.planeTag.nativeElement;
      const replace: any = this.replaceTag.nativeElement;
      plane.classList.add('fly');
      hidden.classList.add('visible');
      replace.classList.remove('fa-paper-plane');
      replace.classList.add('fa-check-circle');
      replace.classList.add('nav-center');
    }
    this.thanksNote = this.showQuestions = true;
    setTimeout(() => {
      this.showAttachOverlay = false;
      this.fetchQuestions();
    }, 2500);
    this.inProgress = false;
    http.onerror = () => {
      this.inProgress = false;
      this.backEndError = true;
    };
    http.send(JSON.stringify(data));
    
    
  }

  goToNextQues(question, index, $event) {
    let obj = {};
    obj['answer'] = $event.target.value;
    obj['question'] = question;
    this.answered[index] = obj;
    const answered = this.answered.filter((x) => x.answer);
    const dynamicWidth = this.questionCount = answered.length;
    this.dynamicWidth = (dynamicWidth / this.questions.length) * 100;
    const ele: any = this.questionsTag.toArray()[index].nativeElement;
    if (ele && ele.nextElementSibling)
      ele.nextElementSibling.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  onSend(event) {
    this.screenShotName = this.ipnSelected + '_' + this.irnSelected + '_' + new Date().toLocaleString('de-DE', {timeZone: 'Europe/Paris' });
    this.showAttachOverlay = true;
    this.screenshot = event.screenshot;
    this.isShow = true;
  }

  resetScreenshot() {
    this.screenShotName = '';
    this.screenshot = '';
  }

  hitIDP() {
    const clearIDPExpriy = setTimeout(() => {
      clearTimeout(clearIDPExpriy);
      this.hitIDP();
    }, 1798000);
    const http = new XMLHttpRequest();
    const urlencoded = new URLSearchParams();
    // const idpUrl = 'https://idp2.renault.com/nidp/oauth/nam/token';
    let idpUrl = '';
    if(this.apiUrl.indexOf('apis.renault.com') > 0){
      idpUrl = 'https://idp.renault.com/nidp/oauth/nam/token';
    }
    else{
      idpUrl = 'https://idp2.renault.com/nidp/oauth/nam/token';
    }
    urlencoded.append("grant_type", "password");
    urlencoded.append("scope", "arca");
    urlencoded.append("username", this.techIPN);
    urlencoded.append("password", this.techPassword);
    urlencoded.append("client_id", this.clientId);
    urlencoded.append("client_secret", this.clientSecret);
    http.open('POST', idpUrl, true);
    http.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    http.onreadystatechange = () => {
      if (http.readyState === 4) {
        if (http.status === 200) {
          const res = http.responseText ? JSON.parse(http.responseText) : '';
          this.idpFailureCount = 10;
          if (res) {
            this.access_token = 'Bearer ' + res['access_token'];
            this.fetchQuestions();
          } else {
            this.backEndError = true;
          }
        } else {
          this.backEndError = true;
        }
      }
    };
    http.onerror = () => {
      if (this.idpFailureCount !== 0) {
        this.hitIDP();
        this.idpFailureCount -= 1;
      }
    };
    http.send(urlencoded);
  }

  hidePlugin() {
    this.isShow = false;
    setTimeout(() => {
      const feedbackClick: any = this.feedbackBtn.nativeElement;
      feedbackClick.click();
    }, 100);
  }

  element=[
    {lan: 'en', mgs1:'Minimum 10 characters required', mgs2:'Choose lesser than 2MB',mgs3: 'Please provide your comments',mgs4: 'Answered', mgs5: 'Thanks for submitting your feedback!', mgs6:'Powered By'},
    {lan: 'fr', mgs1:'Minimum 10 caractères requis', mgs2:'Choisissez moins de 2MB', mgs3: 'Merci d"apporter vos commentaires',mgs4: 'Répondue', mgs5:'Merci d"'+'avoir soumis vos commentaires !',mgs6:'Alimenté par'},
    {lan: 'de', mgs1:'Mindestens 10 Zeichen erforderlich', mgs2:'Wählen Sie weniger als 2MB', mg3: 'Bitte geben Sie Ihre Kommentare ein',mgs4: 'Antwortete', mgs5:'Vielen Dank für Ihr Feedback!',mgs6:'Bereitgestellt von'},
    {lan: 'es', mgs1:'Mínimo 10 caracteres requeridos', mgs2:'Elija menos de 2 MB', mg3: 'Por favor proporcione sus comentarios', mg4: 'Contestada', mg5: '¡Gracias por enviar sus comentarios!', mg6: 'Energizado por'},
    {lan: 'ru', mgs1:'Требуется минимум 10 символов', mgs2:'Выберите менее 2 МБ', mg3: 'Пожалуйста, предоставьте свои комментарии', mg4: 'Ответил', mg5: 'Спасибо за отзыв!', mg6: 'Питаться от'},
    {lan: 'ja', mgs1:'最低 10 文字が必要です', mgs2:'2MB未満を選択してください', mg3: 'ご意見をお聞かせください', mg4: '答えた', mg5: 'フィードバックを送信していただきありがとうございます。', mg6: '搭載'},
    {lan: 'ro', mgs1:'Sunt necesare minimum 10 caractere', mgs2:'Alegeți mai puțin de 2 MB', mg3: 'Vă rugăm să furnizați comentariile dvs', mg4: 'Răspuns', mg5: 'Vă mulțumim pentru feedback-ul trimis!', mg6: 'Cu sprijinul'},
    {lan: 'pt', mgs1:'Mínimo 10 caracteres obrigatórios', mgs2:'Escolha menos de 2 MB', mg3: 'Forneça seus comentários', mg4: 'Respondidos', mg5: 'Obrigado por enviar seu feedback!', mg6: 'Distribuído por'},
    {lan: 'it', mgs1:'Minimo 10 caratteri richiesti', mgs2:'Scegli meno di 2 MB', mg3: 'Si prega di fornire i propri commenti', mg4: 'Risposto', mg5: 'Grazie per aver inviato il tuo feedback!', mg6: 'Offerto da'},
    {lan: 'ko', mgs1:'최소 10자 필요', mgs2:'2MB 미만 선택', mg3: '귀하의 의견을 제공하십시오', mg4: '대답했다', mg5: '피드백을 제출해 주셔서 감사합니다!', mg6: '에 의해 구동'},
    {lan: 'zh', mgs1:'至少需要 10 个字符', mgs2:'选择小于2MB的', mg3: '请提供您的意见', mg4: '已回答', mg5: '感谢您提交反馈！', mg6: '供电'},
    {lan: 'tr', mgs1:'Minimum 10 karakter gerekli', mgs2:'2MB tan küçük olanı seçin', mg3: 'Lütfen yorumlarınızı belirtin', mg4: 'cevaplandı', mg5: 'Geri bildiriminizi gönderdiğiniz için teşekkür ederiz!', mg6: 'Tarafından desteklenmektedir'},
    {lan: 'ar', mgs1:'الحد الأدنى المطلوب هو 10 أحرف', mgs2:'اختر أقل من 2 ميغا بايت', mg3: 'يرجى تقديم تعليقاتك', mg4: 'أجاب', mg5: 'شكرا لإرسال ملاحظاتك!', mg6: 'مشغل بواسطة'}
  ];
}
